import RoutePath from '@/utils/modules/RoutePath'
import PageName from '@/utils/defines/PageName'
const router = [
	{
		path: RoutePath.Cargo.Main,
		name: PageName.Cargo.Main,
		props: true,
		component: () => import('@/views/cargo/pages/list.vue'),
	},
	{
		path: RoutePath.Cargo.Do,
		name: PageName.Cargo.Do,
		props: true,
		component: () => import('@/views/cargo/pages/cargo.vue'),
	},
	{
		path: RoutePath.Cargo.Detail,
		name: PageName.Cargo.Detail,
		props: true,
		component: () => import('@/views/cargo/pages/detail.vue'),
	},
]

export default router
